import React, { useContext } from 'react'
import { GlobalDataContext } from '../../context/context'
import { ButtonContent } from './boton/ButtonContent'

const VideoPromocional = ({ linkVideo, image, title, text, vimeoVideo }) => {
    const { rpdata } = useContext(GlobalDataContext);
    return (
        <div
            className='bgCountentVideo'
            style={{
                backgroundImage: `url("${image ? image : rpdata?.stock?.[0]}")`
            }}
        >
            <div className='countentVideoInfo '>
                <div className='info'>
                    <h3>{title}</h3>
                    <p>{text}</p>
                    <ButtonContent />
                </div>
                <iframe
                    title="Promotional video"
                    className='w-[90%] h-[280px] md:h-[360px] md:w-[50%] lg:h-[460px] lg:w-[60%] mx-auto rounded-3xl relative top-[80px] md:top-[150px]'
                    src={`${linkVideo}`}
                    width="640" height="360"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                />
            </div>
        </div>
    )
}

export default VideoPromocional


